import { MutationOptions } from 'react-query';
import { queryClient } from '../../../queryClient';
import { enableOrgFeature, disableOrgFeature } from './features.api';
interface ToggleOrgFeatureVars {
  featureId: number;
  enabled: boolean;
}

export const getToggleOrgFeatureMutation = (
  orgId: number,
): MutationOptions<unknown, Error, ToggleOrgFeatureVars> => ({
  mutationFn: ({ featureId, enabled }) =>
    enabled
      ? enableOrgFeature(orgId, featureId)
      : disableOrgFeature(orgId, featureId),
  onSuccess: () =>
    queryClient.invalidateQueries({
      queryKey: [{ scope: 'features', type: 'org', orgId }],
      exact: false,
    }),
});
